export default __webpack_public_path__ + "static/media/postgre.f94cfa2e.png";